import React from 'react';
import services from './Services';
import { Link } from 'react-router-dom';

const ServicesSlideshow = () => {
  return (
<div
  className="overflow-hidden px-4 max-w-6xl mx-auto py-20 bg-fixed bg-center"
  style={{
    backgroundImage: `url('/path-to-parallax-image.jpg')`,
    backgroundSize: 'cover',
  }}
>
  <h2 className="text-center text-3xl text-[#121A31] font-bold mb-10">OUR SERVICES</h2>
  <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
    {services.map((service) => (
      <div
        key={service.id}
        className="p-6 bg-white rounded-lg shadow-md border border-gray-200 hover:border-[#124E66]"
      >
        <h3 className="text-xl font-semibold mb-2 text-[#748D92]">{service.title}</h3>
        <p className="text-gray-700">{service.description}</p>
      </div>
    ))}
  </div>
  <div className="pt-10 flex justify-center">
    <Link to={'/services'}>
      <button className="bg-[#748D92] text-white font-semibold hover:bg-[#124E66] p-2 w-40 rounded-full">
        View More
      </button>
    </Link>
  </div>
</div>

  );
};

export default ServicesSlideshow;
